<template>
<div>
  <div v-for="item in items" :key="item.id">
    <p class="txt">{{item.txt}}</p>
  </div>
</div>
</template>

<script>

export default {
    data() {
        return {
          items :[
            {id:1, txt: 'txt1'},
            {id:2, txt: 'txt2'},
            {id:3, txt: 'txt3'},
            {id:4, txt: 'txt4'},
            {id:5, txt: 'サンプル'},
            {id:6, txt: 'サンプル9'},
            {id:6, txt: 'サンプル9'},
          ]
        }
    },
}
</script>

<style scoped lang="scss">
.txt {
  color: red;
}
</style>